var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { ref: "offscreenContainer", staticClass: "offscreen-container" },
      [
        _c(
          "div",
          {
            ref: "viewport",
            staticClass: "thumbnail-viewport",
            style: _vm.viewportStyle,
          },
          [
            _c("canvas", {
              ref: "canvas",
              staticClass: "thumbnail-canvas",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }